/* eslint-disable prefer-const,quote-props */
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _lodash = require("lodash");

var _request = _interopRequireDefault(require("../utils/request"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// TODO: add mobile support for analytics
// import { GoogleAnalyticsTracker } from 'react-native-google-analytics-bridge'
// import DeviceInfo from 'react-native-device-info'
// import { Dimensions } from 'react-native'
// const { height, width } = Dimensions.get('window')
// const webOS = ['aix',
//   'darwin',
//   'freebsd',
//   'linux',
//   'openbsd',
//   'sunos',
//   'win32']
var webSuperProperties = {
  height: window.screen.height,
  width: window.screen.width,
  browserCodeName: navigator.appCodeName,
  deviceAgent: navigator.userAgent,
  browserName: navigator.appName,
  browserVersion: navigator.appVersion,
  cookieEnabled: navigator.cookieEnabled,
  language: navigator.language,
  online: navigator.onLine,
  product: navigator.product,
  productSub: navigator.productSub,
  docURI: document.documentURI,
  platform: 'WEB',
  domain: document.domain
}; // const mobileSuperProperties = {
//   appVersion: DeviceInfo.getVersion(),
//   brand: DeviceInfo.getBrand(),
//   deviceCountry: DeviceInfo.getDeviceCountry(),
//   deviceModel: DeviceInfo.getModel(),
//   deviceLocale: DeviceInfo.getDeviceLocale(),
//   manufacturer: DeviceInfo.getManufacturer(),
//   os: DeviceInfo.getSystemName(),
//   osVersion: DeviceInfo.getSystemVersion(),
//   timeZone: DeviceInfo.getTimezone(),
//   deviceHeight: height,
//   deviceWidth: width,
//   platform: 'MOBILE',
//   product: navigator.product
// }

var superProperties = webSuperProperties;
// map the new events for to old events for google analytics
// const googleAnalyticsEventMapping = {
//   SAVE_CONTENT: {
//     category: 'Offline',
//     action: 'Save Content'
//   },
//   REMOVE_CONTENT: {
//     category: 'Offline',
//     action: 'Remove Content'
//   },
//   SHARE_CONTENT: {
//     category: 'Share',
//     action: 'Share Content'
//   },
//   VIEW_CONTENT: {
//     category: 'View'
//   },
//   NOTES_SAVED: {
//     category: 'Notes',
//     action: 'Notes Saved'
//   },
//   NOTES_REMOVED: {
//     category: 'Notes',
//     action: 'Notes Removed'
//   },
//   SHARE_NOTES: {
//     category: 'Share',
//     action: 'Share Notes'
//   },
//   OPEN_EVENT: {
//     categroy: 'Event',
//     action: 'Open event'
//   },
//   ADD_EVENT: {
//     category: 'Event',
//     action: 'Add event'
//   }
// }
// type GoogleAnalyticsEvent = {
//   value?:string,
//   category?: string,
//   action: string,
//   label: string
// }
var tracker;
var timedEvents = {};

var AnalyticsWorker = /*#__PURE__*/function () {
  function AnalyticsWorker(accessToken, winterGreenURL, logger, googleAnalyticsId) {
    _classCallCheck(this, AnalyticsWorker);

    _defineProperty(this, "request", void 0);

    _defineProperty(this, "headers", void 0);

    _defineProperty(this, "logger", void 0);

    // if (!isEmpty(googleAnalyticsId)) {
    //   tracker = new GoogleAnalyticsTracker(googleAnalyticsId)
    // }
    this.logger = logger;
    this.headers = {
      headers: {
        'Authorization': 'Bearer ' + accessToken
      }
    };
    this.request = new _request["default"](winterGreenURL, logger, true);
  }
  /**
  * Get Google Analytics event object mapped from style eventName and properties
  * @param  {string} eventName  name of the event
  * @param  {object} properties properties object
  * @return {object}            Google Analytics event object
  */
  // getGoogleAnalyticsEvent (eventName: string, properties?: Object): ?GoogleAnalyticsEvent {
  //   switch (eventName) {
  //     case 'Content Opened':
  //       return {
  //         ...googleAnalyticsEventMapping['VIEW_CONTENT'],
  //         action: get(properties, 'contentLocation') || '',
  //         label: get(properties, 'contentTitle') || ''
  //       }
  //     case 'Content For Offline Saved':
  //       return {
  //         ...googleAnalyticsEventMapping['SAVE_CONTENT'],
  //         label: get(properties, 'contentTitle') || ''
  //       }
  //     case 'Content Removed From Device':
  //       return {
  //         ...googleAnalyticsEventMapping['REMOVE_CONTENT'],
  //         label: get(properties, 'contentTitle') || ''
  //       }
  //     case 'Content Shared':
  //       return {
  //         ...googleAnalyticsEventMapping['SHARE_CONTENT'],
  //         label: get(properties, 'contentTitle') || ''
  //       }
  //     case 'Event Opened':
  //       return {
  //         ...googleAnalyticsEventMapping['OPEN_EVENT'],
  //         label: get(properties, 'eventTitle') || ''
  //       }
  //     case 'Event Added':
  //       return {
  //         ...googleAnalyticsEventMapping['ADD_EVENT'],
  //         label: get(properties, 'title') || ''
  //       }
  //     default:
  //       return null
  //   }
  // }


  _createClass(AnalyticsWorker, [{
    key: "postStopTimedEvent",
    value: function () {
      var _postStopTimedEvent = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(eventId, accountId) {
        var mutation, body;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                mutation = "mutation stopTimedEvent ($eventId: String!, $account: String!) {\n    stopTimedEvent (eventId: $eventId, account: $account)\n  }";
                body = {
                  query: mutation,
                  variables: {
                    eventId: eventId,
                    account: accountId
                  }
                };
                _context.next = 4;
                return this.request.post(body, '/graphql', this.headers);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function postStopTimedEvent(_x, _x2) {
        return _postStopTimedEvent.apply(this, arguments);
      }

      return postStopTimedEvent;
    }()
    /**
    * Track an event mapped to the old Google Analytics
    * @param  {string} eventName  name of the event
    * @param  {object} properties properties object
    */
    // trackGoogleAnalyticsEvent (eventName: string, properties?: Object) {
    //   if (tracker) {
    //     const googleAnalyticsEvent = this.getGoogleAnalyticsEvent(eventName, properties)
    //     if (googleAnalyticsEvent) {
    //       const options = {}
    //       if (googleAnalyticsEvent.label) {
    //         options.label = googleAnalyticsEvent.label
    //       }
    //       if (googleAnalyticsEvent.value) {
    //         options.value = googleAnalyticsEvent.value
    //       }
    //       tracker.trackEvent(googleAnalyticsEvent.category, googleAnalyticsEvent.action, options)
    //     }
    //   }
    // }

  }, {
    key: "startTimedEvent",
    value: function () {
      var _startTimedEvent = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(eventType, data, accountId, userId) {
        var timedEvent, id;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                timedEvent = {
                  eventType: eventType,
                  account: accountId,
                  user: userId,
                  data: (0, _lodash.merge)(data, superProperties)
                };
                _context2.next = 3;
                return this.postStartTimedEvent(timedEvent);

              case 3:
                id = _context2.sent;
                timedEvents[eventType] = id;

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function startTimedEvent(_x3, _x4, _x5, _x6) {
        return _startTimedEvent.apply(this, arguments);
      }

      return startTimedEvent;
    }()
  }, {
    key: "stopTimedEvent",
    value: function stopTimedEvent(eventType, accountId) {
      var eventId = timedEvents[eventType];

      if (!(0, _lodash.isNil)(eventId)) {
        this.postStopTimedEvent(eventId, accountId);
        delete timedEvents[eventType];
      }
    } // @Flow-fix-me

  }, {
    key: "getTimedEventIds",
    value: function getTimedEventIds() {
      return (0, _lodash.values)(timedEvents);
    }
  }, {
    key: "stopAllTimedEvents",
    value: function stopAllTimedEvents(accountId) {
      var _this = this;

      (0, _lodash.forEach)((0, _lodash.keys)(timedEvents), function (type) {
        _this.stopTimedEvent(type, accountId);
      });
    }
    /**
    * track an analytics event
    * @param  {string} eventName  name of the event
    * @param  {object} properties properties object
    */

  }, {
    key: "trackEvent",
    value: function trackEvent(event) {
      var eventType = event.type;
      var finalEvent = (0, _lodash.merge)(event.properties, superProperties, {
        eventType: eventType,
        timedEvents: this.getTimedEventIds(),
        dateTime: Date.now()
      });
      this.postAnalyticEvent(finalEvent); // this.trackGoogleAnalyticsEvent(event.type, finalEvent)
    }
  }, {
    key: "postStartTimedEvent",
    value: function () {
      var _postStartTimedEvent = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(timedEvent) {
        var mutation, body, result;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                mutation = "mutation startTimedEvent ($timedEvent: AnalyticEvent!) {\n    startTimedEvent (timedEvent: $timedEvent)\n  }";
                body = {
                  query: mutation,
                  variables: {
                    timedEvent: timedEvent
                  }
                };
                _context3.next = 4;
                return this.request.post(body, '/graphql', this.headers);

              case 4:
                result = _context3.sent;
                return _context3.abrupt("return", result.body.data.startTimedEvent);

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function postStartTimedEvent(_x7) {
        return _postStartTimedEvent.apply(this, arguments);
      }

      return postStartTimedEvent;
    }()
  }, {
    key: "postAnalyticEvent",
    value: function postAnalyticEvent(analyticEvent) {
      var mutation = "mutation addAnalyticEvent ($event: AnalyticEvent!) {\n    addAnalyticEvent (event: $event)\n  }";
      var body = {
        query: mutation,
        variables: {
          event: analyticEvent
        }
      };
      this.request.post(body, '/graphql', this.headers);
    }
    /**
     * track an analytics event only if it is not an error or just a start
     * @param  {string|$ReadOnlyArray} eventName  type of the event
     * @param  {object} properties properties object
     * @param  {string|$ReadOnlyArray} rawType type of action that initiated the analytics action
     */

  }, {
    key: "conditionalTrackEvent",
    value: function conditionalTrackEvent(eventType, properties, rawType) {
      if ((0, _lodash.includes)(rawType, 'SUCCESS') || !(0, _lodash.includes)(rawType, 'START') && !(0, _lodash.includes)(rawType, 'ERROR')) {
        var event = {
          type: eventType,
          properties: properties
        };
        this.trackEvent(event);
      }
    }
    /**
     * get properties for analytics event
     * @param  {AnalyticsEvent} event analytics event object
     * @param  {Object} state app state data
     * @return {Object}       properties for the analytics event
     */

  }, {
    key: "getEventProperties",
    value: function getEventProperties(event, state) {
      var rawArgs = (0, _lodash.get)(event, 'meta.rawArgs');
      var getProperties = (0, _lodash.get)(event, 'meta.getProperties');

      if ((0, _lodash.isFunction)(getProperties)) {
        return _objectSpread(_objectSpread({}, event.payload), getProperties.apply(void 0, [state].concat(_toConsumableArray(rawArgs))));
      }

      return event.payload;
    }
    /**
       * track an action
       * @param  {AnalyticsEvent} event the analytics event
       * @param  {Object} state app state data
       */

  }, {
    key: "trackAction",
    value: function trackAction(event, state) {
      var type = event.type;
      var rawType = (0, _lodash.get)(event, 'meta.rawType');
      var properties = this.getEventProperties(event, state) || {};
      this.conditionalTrackEvent(type, properties, rawType);
    }
  }, {
    key: "trackScreenView",
    value: function trackScreenView(screenName, appProfileProperties) {
      if (tracker) {
        tracker.trackScreenView(screenName);
      }

      var event = {
        type: 'Page View',
        properties: _objectSpread({
          pageName: screenName
        }, appProfileProperties)
      };
      this.trackEvent(event);
    }
  }]);

  return AnalyticsWorker;
}();

exports["default"] = AnalyticsWorker;

_defineProperty(AnalyticsWorker, "postAnalyticEvent", void 0);